import React from 'react';
import { Tag } from 'antd';
import {
  arrayOf, func, number, oneOfType, shape, string,
} from 'prop-types';
import FileIcon from 'components/file-icon';
import { fileExtension } from 'components/attachments/fileValidation';

const CommentAttachments = ({ fileList = [], setFileList = (_files) => {} }) => {
  if (fileList.length === 0) return null;

  const removeFile = (uid) => {
    setFileList((prev) => prev.filter((file) => file.uid !== uid));
  };

  return (
    <div className="ticket-comments-form__attachments">
      <div className="ticket-comments-form__attachment-chips">
        {fileList.map((file) => (
          <Tag
            key={file.uid}
            closable
            onClose={() => removeFile(file.uid)}
            icon={<FileIcon format={fileExtension(file)} />}
            className="ticket-comments-form__attachment-chip"
          >
            <span className="ticket-comments-form__attachment-name">{file.name}</span>
          </Tag>
        ))}
      </div>
    </div>
  );
};

CommentAttachments.propTypes = {
  fileList: arrayOf(shape({
    uid: oneOfType([number, string]),
    name: string,
    size: number,
  })),
  setFileList: func,
};

export default CommentAttachments;
